
import { defineComponent, ref, onMounted, getCurrentInstance, nextTick, watch } from 'vue'
import { mapState, useStore } from 'vuex'

import COVERAPP from '@/utils/COVERAPP'

export default defineComponent({
    props: ['isApp'],
    setup (props, context) {
        const _this = getCurrentInstance() as any
        const COVER = _this.proxy.$common
        const $store = useStore()
        const shareImg = ref<string>('')
        const shareImgData = $store.state.shareImgData
        let tagImg = [
            require('@/assets/img/share_tag_01.png'),
            require('@/assets/img/share_tag_02.png'),
            require('@/assets/img/share_tag_03.png'),
            require('@/assets/img/share_tag_04.png'),
            require('@/assets/img/share_tag_05.png'),
            require('@/assets/img/share_tag_06.png'),
        ]

        const loadImage = (url: string) => {
            return new Promise((resolve) =>{
                const img = new Image()
                img.crossOrigin = 'Anonymous' 
                img.src = url
                img.addEventListener('load', () => {
                    resolve(img)
                })
            })
        }

        const shareImage = () => {
            COVERAPP.Method.shareImage({
                title: $store.state.shareData.title,
                desc: $store.state.shareData.desc,
                imgUrl: $store.state.shareData.imgUrl,
                link: $store.state.shareData.link,
                image: shareImg.value.split(';base64,')[1],
                callback (ret: any) {
                    const data = typeof ret == 'string'.toLowerCase() ? JSON.parse(ret) : ret 
                    const origin = data.origin || ''
                    if (origin != 'None' && !COVER.isEmpty(origin)) {
                        COVER.track('share', '分享图片到' + origin)
                    } else {
                        COVER.track('share', '分享图片');
                    }
                }

            })
        }

        let resultImg = ''
        const draw = () => {
            let loadImgs = [
                loadImage(require('@/assets/img/map.jpg')),
                loadImage(require('@/assets/img/share_bg_01.png')), 
                loadImage(require('@/assets/img/share_bg_02.png')), 
                loadImage(require('@/assets/img/share_bg_03.png')), 
                loadImage(tagImg[shareImgData.tag]), 
                loadImage(require('@/assets/img/seat_icon.png')),
            ]
            shareImgData.imgList.forEach((val) => {
                loadImgs.push(loadImage(val.info.img))
            })
            Promise.all(loadImgs).then((imgs: any) => {
                const mapImageEelement = document.querySelector('.puzzle-map-img') as HTMLImageElement
                const size = mapImageEelement.naturalWidth / mapImageEelement.width
                const py = shareImgData.imgList[shareImgData.imgList.length - 1].pos[1] * size + 380
                const c: HTMLCanvasElement = document.createElement('canvas')
                const ctx = c.getContext('2d') as CanvasRenderingContext2D
                const cSize = 616 / imgs[0].width
                c.width = 1080
                c.height = 1115 + py * cSize
                let pattern = ctx.createPattern(imgs[2], 'repeat') as any
                ctx.fillStyle = pattern
                ctx.fillRect(0, 900, c.width, py * cSize - 245)
                ctx.drawImage(imgs[1], 0, 0, imgs[1].width, imgs[1].height, 0, 0, imgs[1].width, imgs[1].height)
                ctx.drawImage(imgs[3], 0, 0, imgs[3].width, imgs[3].height, 0, 654 + py * cSize, imgs[3].width, imgs[3].height)
                ctx.drawImage(imgs[4], 0, 0, imgs[4].width, imgs[4].height, 190, 270, imgs[4].width, imgs[4].height)
                ctx.drawImage(imgs[0], 0, 0, imgs[0].width, py, 236, 680, 616, py * cSize)
                shareImgData.imgList.forEach((val, index) => {
                    const img = imgs[index + 6]
                    const imgSize = (300 / 970) / (img.width / imgs[0].width)
                    const imgW = img.width * cSize * imgSize
                    const imgH = img.height * cSize * imgSize
                    const x = 236 + cSize * val.pos[0] * size
                    const y = 680 + cSize * val.pos[1] * size
                    ctx.drawImage(img, 0, 0, img.width, img.height, x, y, imgW, imgH)
                    const iconW = imgs[5].width / 1.8
                    const iconH = imgs[5].height / 1.8
                    ctx.drawImage(imgs[5], 0, 0, imgs[5].width, imgs[5].height, x + imgW / 2 - iconW / 2, y - iconH / 2, iconW, iconH)
                    ctx.fillStyle = '#050401'
                    ctx.font = '28px FZY4K'
                    ctx.textAlign = 'center'
                    ctx.textBaseline = 'top'
                    const l = x + imgW / 2
                    const t = y + imgH - (val.info.dis || 1) * 11 * cSize * imgSize - 28 * 1.2
                    ctx.lineWidth = 7
                    ctx.strokeStyle = '#fff'
                    ctx.strokeText(val.info.text, l, t)
                    ctx.fillText(val.info.text, l, t)
                    resultImg = c.toDataURL('image/png', .8)
                })              
            })
        }

        watch(() => $store.state.isCreating, (val) => {
            if (!val) {
                shareImg.value = resultImg
                $store.commit('SET_MESSAGEDATA', null)
                if (props.isApp) {
                    shareImage()
                    nextTick(() => {
                        $store.commit('SET_SHAREIMGDATA', null)
                    })
                }
            }
        })

        const close = () => {
            $store.commit('SET_SHAREIMGDATA', null)
        }

        onMounted(() => {
            draw()
        })

        return {
            shareImg,
            close
        }
    }
})
